import {createGlobalContext} from '@acng/frontend-relativity';
import {documentElement} from '@acng/frontend-bounty';
import {CTX_PROVIDE, CTX_VALUE} from '@acng/frontend-relativity/minify';

import {ctxGlobalDialog, setGlobalDialog} from './global-dialog.js';

/**
 * @typedef {import("../model/message").MessageData} MessageData
 */

export const ctxReceivedMessage = createGlobalContext(/** @type {MessageData?} */ (null));

const SOCK_EVENT = 'message.received';

/**
 * @deprecated (angularjs)
 */
export const runReceivedMessageContext = [
  'sock',
  /**
   * @param {core.Sock} sock
   */
  (sock) => {
    sock.registerHandler(SOCK_EVENT, (msg) => ctxReceivedMessage[CTX_PROVIDE](null, msg));
    sock.registerHandler(
      SOCK_EVENT,
      /**
       * @param {MessageData} msg
       */
      function firstReceivedMessageHandler(msg) {
        sock.unregisterHandler(SOCK_EVENT, firstReceivedMessageHandler);

        const amateurId = msg.sender;
        DEBUG: if (!amateurId) {
          throw TypeError();
        }

        if (!ctxGlobalDialog[CTX_VALUE](documentElement) && window.innerWidth >= 768) {
          setGlobalDialog(amateurId);
        }
      }
    );
  },
];
